import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { FormInput } from './common';
import { PolicyFormProps } from './types';
import { useFarePrograms } from 'common/fare-programs';
import { MultiSelect } from 'common/select';
import { FareProgram } from 'graphql.g';
import * as strings from 'strings';

type FareProgramInputProps = Pick<PolicyFormProps, 'policy' | 'setPolicy'>;

interface FareProgramOption {
    value: FareProgram;
    label: string;
}

function FareProgramInput({ policy, setPolicy }: FareProgramInputProps) {
    const availableFarePrograms = useFarePrograms();
    const intl = useIntl();
    const fareProgramOptions: FareProgramOption[] =
        availableFarePrograms?.map(fp => ({
            value: fp,
            label: intl.formatMessage(strings.farePrograms[fp])
        })) ?? [];
    const selectedFarePrograms = new Set(policy.farePrograms);

    return !!availableFarePrograms && availableFarePrograms.length > 1 ? (
        <FormInput
            labelId="fare-program-select-input"
            label={
                <FormattedMessage
                    key="fare-program-label"
                    defaultMessage="Fare Programs:"
                />
            }
        >
            <MultiSelect<FareProgramOption, true>
                options={fareProgramOptions}
                onChange={selection =>
                    setPolicy({
                        ...policy,
                        farePrograms: selection.map(option => option.value)
                    })
                }
                value={fareProgramOptions.filter(option =>
                    selectedFarePrograms.has(option.value)
                )}
            />
        </FormInput>
    ) : null;
}

export default FareProgramInput;
